import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ AsyncThunk : récupère les KPI selon période et statut
export const fetchKpis = createAsyncThunk(
  "kpi/fetchKpis",
  async ({ period, status = "passe" } = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}prestataire/kpis?period=${period}&status=${status}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
const kpiSlice = createSlice({
  name: "kpi",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchKpis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKpis.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchKpis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default kpiSlice.reducer;
